<template>
	<div class="pages">
		<section class="fx filter-list">
			<!--<div class="fx fx-wrap fx-fill">
				<z-select :options="recommendItems" class="w150 m-l-10"></z-select>
			</div>-->
			<div class="fx fx-wrap fx-fill"></div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入红包名称..." @handleSearch="handleOffset(0)"></z-search></div>
			
		</section>
		<!--列表-->
		<div id="list">
			<z-table :offset="params.offset" :count="params.count" :total-count="envelopeList.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in envelopeList.list || []">
					<td>{{item.name}}</td>
					<td>
						<span v-if="item.send_rule.pay_fee">
							{{item.send_rule.pay_fee | filterMoney}}
						</span>
						<span v-else>
							无限制
						</span>
					</td>
					<td>{{item.send_rule.amount | filterMoney}}</td>
					<td>{{item.send_rule.count}}</td>
					<td>{{item.send_rule.single_min_amount | filterMoney}}</td>
					<td>{{item.send_rule.single_max_amount | filterMoney}}</td>
					<td>{{item.l_time | momentFmt}}</td>
					<td class="operating">
						<a class="operat-btn" @click="handleEdit(item.id)"><i class="icon-edit"></i><span>编辑</span></a>
						<a class="operat-btn" @click="handleShowInfo(item.id)"><i class="icon-look"></i><span>详情</span></a>
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>确定删除红包?不可恢复哟~</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDelete(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
						<a class="operat-btn" @click="handleShopList(item.id)"><i class="icon-look"></i><span>适用门店</span></a>
					</td>
				</tr>
				<div slot="operate">
					<a class="z-btn z-btn-primary b-r-3" @click="handleEdit()">添加裂变红包</a>
				</div>
			</z-table>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'EnvelopeList',
		components: {},
		data() {
			return {
				columns: ['红包名称', '消费金额（元）', '红包总额（元）', '红包个数（个）', '最小金额（元）', '最大金额（元）', '最后更新时间', '操作'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',//查询字符串
				}
			}
		},
		mounted() {
			this.handleEnvelopeList();
		},
		computed: {
			...mapState({
				envelopeList: state => state.envelope.envelopeList
			})
		},
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			//查看红包详情
			handleShowInfo(id = null) {
				this.$router.push({ name: 'redPacketInfo', query: { envelopeId: id}});
			},
			//查看门店列表
			handleShopList(id) {
				this.$router.push({ name: 'redPacketShopListPage', query: { envelopeId: id}});
			},
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleEnvelopeList();
			},
			//新增或者编辑卡券
			handleEdit(id = null) {
				this.$router.push({ name: 'redPacketEdit', query: { envelopeId: id}});
			},
			//获取红包列表
			async handleEnvelopeList() {
				await this.getEnvelopeList(this.params);
				this.$log('获取红包列表成功');
			},
			//删除红包
			async handleDelete(id) {
				try {
					await this.delEnvelope({id: id});
					this.params.offset = 0;
					await this.getEnvelopeList(this.params);
					this.$log('删除成功');
				} catch(e) {
					this.$log('删除失败');
				}
			},
			...mapActions(['getEnvelopeList', 'delEnvelope']),
		},
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	table img {
		width: 50px;
		height: 50px;
	}
	
	.pages {
		background: #FFFFFF;
		border: 1px solid #EBEDEE;
    		border-bottom: none;
		.filter-list {
			padding: 1rem;
		}
	}
	
	.table-cont {
		background: $color-white;
	}
	
	.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	
	table .operating {
		i,
		span {
			width: 68px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// RedPacketListPage.vue?4ee1bfa2